module.exports = __webpack_public_path__ + "static/media/ic-more-three-dots.8d55540a.svg";